import { ColorOrTransparent } from "./types";

export const COLORS = [
  "#201515",
  "#95928e",
  "#ce482d",
  "#ffbf6e",
  "#ffd300",
  "#0f884e",
  "#3d4592",
  "#c1b7ff",
  "#fff",
  "#d7d5d2",
  "#e8e7e4",
  "#feb7a8",
  "#fff3e6",
  "#fcea93",
  "#ade2c8",
  "#b2bce9",
  "#ebd9fa",
] as const;

export const COLORS_WITH_TRANSPARENCY = [...COLORS, "transparent"] as const;

export const COLORS_LABEL: { [key in ColorOrTransparent]: string } = {
  ["#201515"]: "Black",
  ["#95928e"]: "Dark gray",
  ["#ce482d"]: "Red",
  ["#ffbf6e"]: "Orange",
  ["#ffd300"]: "Yellow",
  ["#0f884e"]: "Green",
  ["#3d4592"]: "Blue",
  ["#c1b7ff"]: "Purple",
  ["#fff"]: "White",
  ["#d7d5d2"]: "Gray",
  ["#e8e7e4"]: "Light gray",
  ["#feb7a8"]: "Light red",
  ["#fff3e6"]: "Light orange",
  ["#fcea93"]: "Light yellow",
  ["#ade2c8"]: "Light green",
  ["#b2bce9"]: "Light blue",
  ["#ebd9fa"]: "Light purple",
  transparent: "Transparent",
};

/* Based on https://github.com/remirror/remirror/blob/main/packages/remirror__extension-link/src/link-extension.ts#L52-L54
   Matches Remirror's autolink logic since we have that feature turned on */
export const DEFAULT_AUTO_LINK_REGEX =
  /(?:(?:(?:https?|ftp):)?\/\/)?(?:\S+(?::\S*)?@)?(?:(?:[\da-z\u00A1-\uFFFF][\w\u00A1-\uFFFF-]{0,62})?[\da-z\u00A1-\uFFFF]\.)*(?:(?:\d(?!\.)|[a-z\u00A1-\uFFFF])(?:[\da-z\u00A1-\uFFFF][\w\u00A1-\uFFFF-]{0,62})?[\da-z\u00A1-\uFFFF]\.)+[a-z\u00A1-\uFFFF]{2,}(?::\d{2,5})?(?:[#/?]\S*)?/i;

import { TOP_50_TLDS } from "@remirror/extension-link";

// Extended TLD list including popular modern TLDs
// Added "so", "site" for Notion, "ms" for OneDrive (1drv.ms), "ai" for AI services
export const ALLOWED_TLDS = [...TOP_50_TLDS, "ai", "so", "site", "ms"];

export { TOP_50_TLDS };
